export class Address {
  address: string;
  zip: string;
  city: string;
  country: string;

  public setAddress(address: string): Address {
    if(typeof address === 'string') {
      this.address = address;
    }
    return this;
  }

  public setZip(zip: string): Address {
    if(typeof zip === 'string') {
      this.zip = zip;
    }
    return this;
  }

  public setCity(city: string): Address {
    if(typeof city === 'string') {
      this.city = city;
    }
    return this;
  }

  public setCountry(country: string): Address {
    if(typeof country === 'string') {
      this.country = country;
    }
    return this;
  }

  public fromResponse(response) {
    if(response) {
      this
        .setAddress(response.address)
        .setZip(response.zip)
        .setCity(response.city)
        .setCountry(response.country);
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/address/address.model.ts